module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_46.dot-667633f79cc4c5f0b1ac33a7f1033861.svg";